import { passwordStrength } from 'check-password-strength';

document.addEventListener('alpine:init', function () {
    window.Alpine.store('orders', {
        ids: [],
        orders: [],
        show: false,
        loading: false,
        getSelectedOrders () {
            const ids = this.ids.map(id => +id);

            return this.orders
                .filter(order => ids.includes(order.id))
                .sort((a, b) => {
                    return ids.indexOf(a.id) - ids.indexOf(b.id);
                });
        },
        fetchOrders() {
            this.loading = true;

            const existingIds = this.orders.map(order => order.id);
            const nonExistingIds = this.ids.map(id => +id).filter(id => !existingIds.includes(id));

            if (this.ids.length && !nonExistingIds.length && existingIds.every(id => this.ids.map(id => +id).includes(id))) {
                this.loading = false;
                return;
            }

            fetch('/orders?order_ids=' + nonExistingIds.join(','), {
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                }
            })
                .then(response => response.json())
                .then(orders => {
                    this.orders = this.orders.concat(orders);
                    this.loading = false;
                });
        },
        toggleOrderList () {
            this.show = !this.show;
            this.fetchOrders();
        }
    });
});

window.passwordStrength = passwordStrength;
